import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorTypes } from '@common/data-models/misc/errors';
import { ExternalApiData } from '@common/data-models/service/external-api-data';
import { ServiceResponse } from '@common/data-models/service/service-response';
import { ObjectTypes } from '@src/suite/common/enums/object-types';

import { NomWebServicesJson } from './nom-web-services-json';

@Injectable({ providedIn: 'root' })
export class ExternalActionsService {
    public ExternalActions: Array<ExternalAction> = [];

    private externalActionsCache: { [id: string]: Array<ExternalAction> } = {};
    public getExternalActionsFor(rec: StorytellingRecord): Array<ExternalAction> {
        if (!rec?.Type) return [];
        if (this.externalActionsCache[rec.Type]) return this.externalActionsCache[rec.Type];
        if (this.ExternalActions.length > 0) {
            switch (rec.Type) {
                case ObjectTypes.TOPIC: {
                    const topicActions = this.ExternalActions.filter(item => item.TopicAction);
                    this.externalActionsCache[rec.Type] = topicActions;
                    break;
                }
                case ObjectTypes.ASSIGNMENT: {
                    const assignmentActions = this.ExternalActions.filter(item => {
                        if (rec.Guid) {
                            return item.AssignmentAction;
                        }
                        return item.AssignmentAction && item.ID === 'DELETE';
                    });
                    this.externalActionsCache[rec.Type] = assignmentActions;
                    break;
                }
                case ObjectTypes.PUBLICATION_CHANNEL:
                case ObjectTypes.PUBLICATIONLIST: {
                    const publicationChannel = this.ExternalActions.filter(item => {
                        if (item.ID === 'DUPLICATE') return false;
                        return item.PublicationListAction;
                    });
                    this.externalActionsCache[rec.Type] = publicationChannel;
                    break;
                }
                case ObjectTypes.SCRIPT: {
                    const scriptActions = this.ExternalActions.filter(item => item.ScriptAction);
                    this.externalActionsCache[rec.Type] = scriptActions;
                    break;
                }
            }
            return this.externalActionsCache[rec.Type];
        }
        return [];
    }

    public getExternalActionsForType(t: number): Array<ExternalAction> {
        if (!t) return [];
        if (this.externalActionsCache[t]) return this.externalActionsCache[t];
        if (this.ExternalActions.length > 0) {
            if (t === ObjectTypes.TOPIC) {
                const topicActions = this.ExternalActions.filter(item => item.TopicAction);
                this.externalActionsCache[t] = topicActions;
            }
            if (t === ObjectTypes.ASSIGNMENT) {
                const assignmentActions = this.ExternalActions.filter(item => item.AssignmentAction);
                this.externalActionsCache[t] = assignmentActions;
            }
            if (t === ObjectTypes.PUBLICATION_CHANNEL || t === ObjectTypes.PUBLICATIONLIST) {
                const publicationChannel = this.ExternalActions.filter(item => {
                    if (item.ID === 'DUPLICATE') return false;
                    return item.PublicationListAction;
                });
                this.externalActionsCache[t] = publicationChannel;
            }
            return this.externalActionsCache[t];
        }
        return [];
    }

    public getExternalActionsForV2(rec: StorytellingRecord): Array<ExternalAction> {
        if (!rec?.Type) return [];
        if (this.externalActionsCache[rec.Type]) return this.externalActionsCache[rec.Type];
        if (this.ExternalActions.length > 0) {
            switch (rec.Type) {
                case ObjectTypes.TOPIC: {
                    const topicActions = this.ExternalActions.filter(item => item.TopicAction);
                    this.externalActionsCache[rec.Type] = topicActions;
                    break;
                }
                case ObjectTypes.ASSIGNMENT: {
                    const assignmentActions = this.ExternalActions.filter(item => {
                        if (rec.Guid) {
                            return item.AssignmentAction;
                        }
                        return item.AssignmentAction && item.ID === 'DELETE';
                    });
                    this.externalActionsCache[rec.Type] = assignmentActions;
                    break;
                }
                case ObjectTypes.PUBLICATION_CHANNEL:
                case ObjectTypes.PUBLICATIONLIST: {
                    const publicationChannel = this.ExternalActions.filter(item => {
                        if (item.ID === 'DUPLICATE') return false;
                        return item.PublicationListAction;
                    });
                    this.externalActionsCache[rec.Type] = publicationChannel;
                    break;
                }
                case ObjectTypes.SCRIPT: {
                    const scriptActions = this.ExternalActions.filter(item => item.ScriptAction);
                    this.externalActionsCache[rec.Type] = scriptActions;
                    break;
                }
            }
            return this.externalActionsCache[rec.Type];
        }
        return [];
    }

    constructor(public nomWebServicesJson: NomWebServicesJson) {}

    public async postExternalAction(data: ExternalApiData): Promise<ServiceResponse<ExternalActionResponse>> {
        let responseBody = {} as ExternalActionResponse;
        let responseBool = false;
        let res: HttpResponse<any> = null;
        try {
            res = await this.nomWebServicesJson.post('/api/ExternalActions', data, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'X-ENPS-TOKEN': this.nomWebServicesJson.NomTokenId,
                }),
                responseType: 'json',
                observe: 'response',
            });
            if (res.status >= 200 && res.status < 300) {
                responseBool = true;
            }
        } catch (e) {
            this.nomWebServicesJson.showErrorModal(
                {
                    message: 'Fail to execute external action!',
                    detailMessage: `Fail to execute external action! \n\rStackTrace: NomWebServicesJson.postExternalAction(); \n\rError: ${e}`,
                },
                ErrorTypes.ERROR
            );
        }
        try {
            if (res) {
                responseBody = <ExternalActionResponse>res.body;
            }
        } catch (err) {
            console.log(err);
        }
        return new ServiceResponse<any>(responseBool, responseBody);
    }
}
